<template>
  <div class="app-container">
    <TopBar
      class="top-bar"
      title="鲸币收入"
      :arrow-fn="goBack"
    >
      <template v-slot:rightPosition>
        <div class="withdrawal-box" @click="goToWithdrawSetting">
          <SvgIcon icon-class="withdrawal" class-name="withdrawal"></SvgIcon>
          <span>提现设置</span>
        </div>
      </template>
    </TopBar>
    <p class="tips" v-show="activeIndex === 1">当月提现金额，统一在次月15号到账</p>
    <div class="container" :style="{paddingBottom: activeIndex === 1 ? '1.2rem' : 0}">
      <div class="header">
        <p class="header-text">
          可提现鲸币(个)
          <img class="doubt" src="../../assets/images/doubt.png" alt="" @click="goToWhaleCoinExplain">
        </p>
        <div class="header-content">
          <div class="header-number">{{userCoinInfo.income_coin}}</div>
          <div>
            <div class="header-btn" @click="handleWithdrawal" v-if="userCoinInfo.income_coin > 0">提现</div>
          </div>
        </div>
        <Exhibition :list="numTab"></Exhibition>
      </div>
      <Tab class="income-nav" :list="tabList" v-model="activeIndex"></Tab>
      <!-- 收入记录 -->
      <load-more
        v-show="activeIndex === 0"
        :ban="activeIndex !== 0"
        :loadmore="fetchIncomeList"
        :list="incomeList"
        ref="incomeLoadMore"
        class="load-box">
        <template v-slot:default>
          <Item
            class="item"
            v-for="item in incomeList"
            :key="item.id"
            :text="item.business_info.title"
            :desc="item.business_info.desc"
            :time="item.created"
            :money="item.coin"
          >
          </Item>
        </template>
        <template v-slot:noDataTip>
          <p>本月无收入记录</p>
        </template>
      </load-more>
      <!-- 提现记录 -->
      <load-more
        v-show="activeIndex === 1"
        :ban="activeIndex !== 1"
        :loadmore="fetchWithdrawalList"
        :list="withdrawalList"
        ref="withdrawalLoadMore"
        class="load-box">
        <template v-slot:default>
          <div
            class="list-item item withdrawal-item"
            v-for="item in withdrawalList"
            :key="item.id"
          >
            <div class="item-top mb30">
              <div class="item-text">鲸币{{item.yxl_coin_num}}个</div>
              <div class="item-text">{{item.user_income_amount}}元</div>
            </div>
            <div class="item-bottom">
              <p class="item-grey">操作提现时间：{{item.created}}</p>
              <div
                class="item-tips"
                :class="item.status_text === '提现中' ? 'ing' : 'success'"
              >
                {{item.status_text === '提现中' ? '提现中' : '已提现'}}
              </div>
            </div>
          </div>
        </template>
        <template v-slot:noDataTip>
          <p>本月无提现记录</p>
        </template>
      </load-more>
      <TipsPop v-model="tipsShow"></TipsPop>
      <WithdrawalPop
        :show="show"
        :number="userCoinInfo.income_coin"
        v-model="agree"
        @close="handleClose"
        @read="handleAgreementOpen"
        @confirm="handleWithdrawalConfirm"
        @withdraw-error="handleWithdrawError"
      ></WithdrawalPop>
      <OCACSA
        :show="agreementShow"
        v-model="agree"
        @confirm="handleAgreementConfirm"
        @close="goToFundsManage"
      ></OCACSA>
      <SEPA
        :show="agreementSEPAShow"
        v-model="agreeSEPA"
        @confirm="handleAgreementSEPAConfirm"
        @close="goToFundsManageSEPA"
      ></SEPA>
    </div>
  </div>
</template>

<script>
import Tab from "@/components/Tab"
import SvgIcon from "@/components/SvgIcon"
import WithdrawalPop from "./components/WithdrawalPop"
import TipsPop from "./components/TipsPop"
import LoadMore from 'components/LoadMore'
import Exhibition from "./components/Exhibition"
import Item from "./components/Item"
import TopBar from '@/components/TopBar'
import { switchNavigationBar } from '@/utils/utils'
import userCoinInfoMixin from './userCoinInfoMixin'
import { bridge } from '@/mixins'
import { getUserCoinIncome, getWithdrawList, getWithdrawInfo } from '@/api/fundsManage'
import { incomeRecordLocalCache, SEPALocalCache } from './storageAgree'
import OCACSA from './components/AgreementPop/OCACSA'
import SEPA from './components/AgreementPop/SEPA'
import { goToWhaleCoinExplain } from './utils'
import Bridge from '@/frontend-lib/lib/Bridge'

const withdrawalPath = `${location.protocol}//${location.host}/msite/index.html`
export default {
  name: 'incomeRecord',
  mixins: [userCoinInfoMixin, bridge],
  data () {
    const activeIndex = Number(this.$route.query.activeIndex)
    return {
      incomeList: [],
      withdrawalList: [],
      tabList: [
        '收入记录',
        '提现记录'
      ],
      activeIndex: activeIndex ? activeIndex : 0,
      hasIdentity: false, // 是否第三方
      show: false,
      tipsShow: false,
      agreementShow: !incomeRecordLocalCache.isCache,
      agree: incomeRecordLocalCache.isCache,
      agreementSEPAShow: false,
      agreeSEPA: SEPALocalCache.isCache,
    }
  },
  computed: {
    numTab () {
      return [
        {
          text: '累计收入',
          number: this.totalWithdrawa,
        },
        {
          text: '累计消费',
          number: this.userCoinInfo.consume_coin_info.income_coin,
        },
        {
          text: '累计提现',
          number: this.userCoinInfo.withdrawa_coin.have_withdrawal,
        },
      ]
    }
  },
  components: {
    Tab,
    WithdrawalPop,
    TipsPop,
    Exhibition,
    Item,
    LoadMore,
    TopBar,
    SvgIcon,
    OCACSA,
    SEPA
  },
  created () {
    switchNavigationBar(1)
    this.getUserCoinInfo()
    this.fetchWithdrawInfo()
  },
  mounted () {
    this.$unIncome = this.$watch('$refs.incomeLoadMore.ban', function (ban) {
      if (!ban) {
        this.unIncomeTrigger()
        this.$refs.incomeLoadMore._loadMore()
      }
    })
    this.$unWithdrawal = this.$watch('$refs.withdrawalLoadMore.ban', function (ban) {
      if (!ban) {
        this.unWithdrawalTrigger()
        this.$refs.withdrawalLoadMore._loadMore()
      }
    })
    window.addEventListener('appWebviewShow',this.handleAppShow)
    window.addEventListener('appShow', this.handleAppShow)
  },
  beforeDestroy () {
    window.removeEventListener('appWebviewShow',this.handleAppShow)
    window.removeEventListener('appShow', this.handleAppShow)
  },
  methods: {
    handleAppShow () {
      this.activeIndex = 1
      this.handleClose()
      this.getUserCoinInfo()
      this.fetchWithdrawInfo()
      this.unWithdrawalTrigger()
      this.$nextTick(() => {
        this.$refs.withdrawalLoadMore.reset()
      })
    },
    unIncomeTrigger () {
      if (typeof this.$unIncome === 'function') {
        this.$unIncome()
        this.$unIncome = null
      }
    },
    unWithdrawalTrigger () {
      if (typeof this.$unWithdrawal === 'function') {
        this.$unWithdrawal()
        this.$unWithdrawal = null
      }
    },
    // 收入记录
    fetchIncomeList ({ pageNo, pageSize }) {
      return new Promise(resolve => {
        getUserCoinIncome(pageNo, pageSize)
          .then(res => {
            this.unIncomeTrigger()
            this.setIncomeList(res, pageNo)
            resolve(res.data.data)
          })
      })
    },
    setIncomeList (res, pageNo) {
      if (+res.data.code === 0) {
        if (pageNo > 1) {
          this.incomeList = this.incomeList.concat(res.data.data)
        } else {
          this.incomeList = res.data.data
        }
      }
    },
    // 提现记录
    fetchWithdrawalList ({ pageNo, pageSize }) {
      return new Promise(resolve => {
        getWithdrawList(pageNo, pageSize)
          .then(res => {
            this.unWithdrawalTrigger()
            this.setWithdrawalList(res, pageNo)
            resolve(res.data.data)
          })
      })
    },
    setWithdrawalList (res, pageNo) {
      if (+res.data.code === 0) {
        if (pageNo > 1) {
          this.withdrawalList = this.withdrawalList.concat(res.data.data)
        } else {
          this.withdrawalList = res.data.data
        }
      }
    },
    handleWithdrawError (resData) {
      this.$fail(resData.message)
      console.log(resData)
    },
    fetchWithdrawInfo() {
      getWithdrawInfo()
        .then(res => {
          if (res.data.code == 0) {
            this.hasIdentity = res.data.data.hasIdentity
          } else {
            console.log(res)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    goToWithdrawSetting () {
      this.openWebView({
        url: withdrawalPath + '#/consult-withdrawals-setting',
        isCurrentPageOpen: 0
      })
    },
    handleWithdrawalConfirm () {
      incomeRecordLocalCache.setCache()
      this.handleWithdrawal()
    },
    handleWithdrawal () {
      // this.tipsShow = true
      // 是否第三方&&没签约过
      if (this.hasIdentity && !SEPALocalCache.isCache) {
        this.handleAgreementSEPAOpen()
      } else {
        this.show = true
      }
    },
    handleClose () {
      this.show = false
    },
    goToFundsManage () {
      if (incomeRecordLocalCache.isCache) {
        this.agreementShow = false
      } else {
        this.goBack()
      }
    },
    handleAgreementConfirm () {
      incomeRecordLocalCache.setCache()
      this.agreementShow = false
    },
    goToFundsManageSEPA () {
      this.agreementSEPAShow = false
      this.agreeSEPA = false
    },
    handleAgreementSEPAConfirm () {
      SEPALocalCache.setCache()
      this.agreementSEPAShow = false
      this.show = true
    },
    handleAgreementOpen () {
      this.agreementShow = true
    },
    handleAgreementSEPAOpen () {
      this.agreementSEPAShow = true
    },
    goBack () {
      if (this.$route.query.currentPage) {
        this.$router.replace({
          name: 'FundsManage',
          query: {
            noAgreementPop: '1'
          }
        })
      } else {
        new Bridge().call('cancelWebView')
      }
    },
    goToWhaleCoinExplain () {
      goToWhaleCoinExplain()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../styles/mixins.scss";
@import './index.scss';
.top-bar {
  /deep/ .fixed {
    background: #f8f8f8;
  }
  .withdrawal-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .withdrawal {
      font-size: 33px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #21252D;
    }
  }
}
.header {
  .doubt {
    width: 26px;
    vertical-align: middle;
    display: inline-block;
    margin-left: 15px;
  }
  .header-content {
    padding-bottom: 30px;
  }
  .header-drawing {
    font-family: PingFangSC-Regular;
    font-size: 28px;
    margin-top: 30px;
  }
}
.income-nav {
  margin-top: 40px;
}
.load-box {
  .withdrawal-item {
    & > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .item-tips {
      width: 98px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-Regular;
      font-size: 22px;
      &.success {
        background: #F3F5FA;
        color: #ACB4C4;
      }
      &.ing {
        background: rgba(255,243,223,1);
        color: #FF8E02;
      }
    }
  }
}
// 过渡
.switch0-enter-active,
.switch0-leave-active,
.switch1-enter-active,
.switch1-leave-active {
  transition: transform .2s ease-out;
}
.switch0-enter,
.switch0-leave-to {
  transform: translateX(-100%);
}
.switch1-enter,
.switch1-leave-to {
  transform: translateX(100%);
}
.tips {
  width: 10rem;
  line-height: 90px;
  text-align: center;
  font-size: 32px;
  color: #FF8E02;
  background: #fff3df;
  bottom: 0;
  left: 0;
  position: fixed;
}
</style>
